import { Routes } from '@angular/router';
import {
  CARGAR_INGRESOS_ROUTE_CONTEXT,
  MOCK_CARGAR_INGRESOS_ROUTE_CONTEXT,
} from './features/cargar-ingresos/cargar-ingresos-route-context';
import { authGuard } from './features/auth/guards/auth.guard';
import { guestGuard } from './features/auth/guards/guest.guard';
import { configuracionRecaudadorCanDeactivate } from './features/configuracion-recaudador/configuracion-recaudador-can-deactivate.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./features/auth/auth-callback.component').then((m) => m.AuthCallbackComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadComponent: () =>
      import('./layout/shell-layout.component').then((m) => m.ShellLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'cargar-ingresos/carga',
        loadComponent: () =>
          import('./features/cargar-ingresos/carga-manual.component').then(
            (m) => m.CargaManualComponent,
          ),
      },
      {
        path: 'cargar-ingresos/detalle/:id',
        loadComponent: () =>
          import('./features/cargar-ingresos/detalle-archivo.component').then(
            (m) => m.DetalleArchivoComponent,
          ),
      },
      {
        path: 'cargar-ingresos',
        loadComponent: () =>
          import('./features/cargar-ingresos/bandeja-archivos.component').then(
            (m) => m.BandejaArchivosComponent,
          ),
      },
      {
        path: 'procesamiento',
        loadComponent: () =>
          import('./features/procesamiento/procesamiento.component').then(
            (m) => m.ProcesamientoComponent,
          ),
      },
      {
        path: 'confirmacion-pago',
        loadComponent: () =>
          import('./features/confirmacion-pago/confirmacion-pago.component').then(
            (m) => m.ConfirmacionPagoComponent,
          ),
      },
      {
        path: 'matriz-recaudacion',
        loadComponent: () =>
          import('./features/matriz-recaudacion/matriz-recaudacion.component').then(
            (m) => m.MatrizRecaudacionComponent,
          ),
      },
      {
        path: 'reportes/trazabilidad-usuarios',
        loadComponent: () =>
          import('./features/reportes/trazabilidad-usuarios/trazabilidad-usuarios.component').then(
            (m) => m.TrazabilidadUsuariosComponent,
          ),
      },
      {
        path: 'motor-reglas/reglas-recaudadores',
        loadComponent: () =>
          import('./features/motor-reglas/reglas-recaudadores.component').then(
            (m) => m.ReglasRecaudadoresComponent,
          ),
      },
      {
        path: 'motor-reglas/errores-archivos',
        loadComponent: () =>
          import('./features/motor-reglas/errores-archivos.component').then(
            (m) => m.ErroresArchivosComponent,
          ),
      },
      {
        path: 'configuracion',
        redirectTo: 'colmena/configuracion',
        pathMatch: 'full',
      },
      {
        path: 'colmena/configuracion',
        loadComponent: () =>
          import('./features/colmena/configuracion/configuracion-mantenedores.component').then(
            (m) => m.ConfiguracionMantenedoresComponent,
          ),
      },
      {
        path: 'configuracion-recaudador',
        canDeactivate: [configuracionRecaudadorCanDeactivate],
        loadComponent: () =>
          import('./features/configuracion-recaudador/configuracion-recaudador.component').then(
            (m) => m.ConfiguracionRecaudadorComponent,
          ),
      },
      {
        path: 'configuracion-layout-archivos',
        loadComponent: () =>
          import(
            './features/configuracion-layout-archivos/configuracion-layout-archivos.component'
          ).then((m) => m.ConfiguracionLayoutArchivosComponent),
      },
      {
        path: 'configuracion-recaudador-mockup',
        loadComponent: () =>
          import(
            './features/configuracion-recaudador-mockup/configuracion-recaudador-mockup.component'
          ).then((m) => m.ConfiguracionRecaudadorMockupComponent),
      },
      {
        path: 'cargar-ingresos-mockup',
        providers: [
          {
            provide: CARGAR_INGRESOS_ROUTE_CONTEXT,
            useValue: MOCK_CARGAR_INGRESOS_ROUTE_CONTEXT,
          },
        ],
        loadComponent: () =>
          import('./features/cargar-ingresos/bandeja-ingresos.component').then(
            (m) => m.BandejaIngresosComponent,
          ),
      },
      {
        path: 'cargar-ingresos-mockup/carga',
        providers: [
          {
            provide: CARGAR_INGRESOS_ROUTE_CONTEXT,
            useValue: MOCK_CARGAR_INGRESOS_ROUTE_CONTEXT,
          },
        ],
        loadComponent: () =>
          import('./features/cargar-ingresos/carga-manual.component').then(
            (m) => m.CargaManualComponent,
          ),
      },
      {
        path: 'cargar-ingresos-mockup/detalle/:id',
        providers: [
          {
            provide: CARGAR_INGRESOS_ROUTE_CONTEXT,
            useValue: MOCK_CARGAR_INGRESOS_ROUTE_CONTEXT,
          },
        ],
        loadComponent: () =>
          import('./features/cargar-ingresos/detalle-archivo.component').then(
            (m) => m.DetalleArchivoComponent,
          ),
      },
      {
        path: 'vista-archivo/:nombre',
        loadComponent: () =>
          import('./features/cargar-ingresos/vista-archivo.component').then(
            (m) => m.VistaArchivoComponent,
          ),
      },
      {
        path: 'vista-archivo-mockup/:nombre',
        providers: [
          {
            provide: CARGAR_INGRESOS_ROUTE_CONTEXT,
            useValue: MOCK_CARGAR_INGRESOS_ROUTE_CONTEXT,
          },
        ],
        loadComponent: () =>
          import('./features/cargar-ingresos/vista-archivo.component').then(
            (m) => m.VistaArchivoComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
